import {ILevelsService} from './ILevelsService';
import {LevelsRepository} from './LevelsRepository';
import {Level} from '../../graphql/API';

export class LevelsService implements ILevelsService {
  levelsRepository: LevelsRepository;
  constructor() {
    this.levelsRepository = new LevelsRepository();
  }

  async getLevels(): Promise<Array<Level> | any> {
    let levels = await this.levelsRepository.getLevels();
    // //console.log('getLevels from service -->', levels);
    return levels;
  }

  async getNewLevels(): Promise<Array<Level>> {
    const levels = await this.levelsRepository.getNewLevels();
    return levels;
  }

  async getNewLevelById(id: string): Promise<Level | null> {
    const level = await this.levelsRepository.getNewLevelById(id);
    return level;
  }

  async createNewLevel(input: any): Promise<Level | null> {
    const createdLevel = await this.levelsRepository.createNewLevel(input);
    return createdLevel;
  }

  async updateNewLevel(input: any): Promise<Level | null> {
    const updatedLevel = await this.levelsRepository.updateNewLevel(input);
    return updatedLevel;
  }

  async deleteNewLevel(id: string): Promise<any> {
    const result = await this.levelsRepository.deleteNewLevel(id);
    return result;
  }
}
